module.exports = __webpack_public_path__ + "img/gas-meter-lg.05c59ce7.svg";